import { ParsedDate, parseIsoDate } from '@api/Trinium/types';
import { GridValidRowModel } from '@mui/x-data-grid-pro';

/**
 * Represents the raw response type from {site}/Drivers
 */
export interface DriverRaw {
	id: string;
	name: string;
	emailAddr?: string;
	cellPhone?: string;
	hazEndExpDate?: string;
	cdlNo?: string;
	cdlExpDate?: string;
	medExpDate?: string;
	hasELogs?: boolean;
	isTankerEndorsed?: boolean;
	isAssignedJob?: boolean;
	isOnLastJob?: boolean;
	ctrId?: string;
	tractorId?: string;
	brkCntDwn?: string;
	cycleHrs?: string;
	drvnHrs?: string;
	shftHrs?: string;
}

/** Exclude properties that will be parsed out during transform to strongly typed properties */
type ExcludedRawDriverTypes = 'cdlExpDate' | 'medExpDate' | 'hazEndExpDate';

/**
 * Driver API entity used in Driver Data Grid on Driver Dropdown
 */
export type Driver = GridValidRowModel &
	Record<string, string | ParsedDate | null | boolean> &
	Omit<DriverRaw, ExcludedRawDriverTypes> & {
		hazmatExpirationDate?: ParsedDate;
		cdlExpirationDate?: ParsedDate;
		medExpirationDate?: ParsedDate;
	};

export function transformDriverResponse(response: DriverRaw) {
	const { hazEndExpDate, cdlExpDate, medExpDate, isAssignedJob, ...fields } = response;
	return {
		...fields,
		isAssignedJob: isAssignedJob ?? false,
		hazmatExpirationDate: parseIsoDate(hazEndExpDate),
		cdlExpirationDate: parseIsoDate(cdlExpDate),
		medExpirationDate: parseIsoDate(medExpDate)
	} as Driver;
}

export function transformDriversResponse(response: DriverRaw[]) {
	return sortDrivers(response.map((item) => transformDriverResponse(item)));
}

export function sortDrivers(drivers: Driver[]) {
	return drivers.sort((a, b) =>
		a.name.localeCompare(b.name, 'en', {
			sensitivity: 'base'
		})
	);
}
